module.exports = __webpack_public_path__ + "static/media/oops-person.ec9a89f7.png";